import ChevronDown16 from '@carbon/icons-react/es/chevron--down/16';
import styled from 'styled-components';

export const CollapseIcon = styled(ChevronDown16)`
  transition: transform 0.3s;
  transform: rotate(-90deg);
  &.active {
    transform: rotate(0deg);
  }
`;
